import React from "react";
import styles from "./index.module.css";

const Header: React.FC = () => {
  return (
    <header className={styles.mainHeader}>
      <div className={styles.wrapper}>
        <a
          href="https://dataservices.btgpactualsolutions.com/"
          className={styles.logoLink}
        >
          <div className={styles.logoContainer}>
            <img
              src={process.env.REACT_APP_PATH_HOME + "/btg-solutions-logo.png"}
              alt="BTG Pactual"
            />
            <p>Data Services</p>
          </div>
        </a>
        <div className={styles.navContainer}>
          <div className={styles.links}>
            <a href="/" className={styles.active} style={{ color: "#000" }}>
              Home
            </a>
            <a
              href="https://dataservicesdocs.btgpactualsolutions.com/restapi"
              style={{ color: "#000" }}
            >
              Rest API
            </a>
            <a
              href="https://dataservicesdocs.btgpactualsolutions.com/asyncapi"
              style={{ color: "#000" }}
            >
              Websocket
            </a>
          </div>
        </div>
        <div className={styles.dummy}></div>
      </div>
    </header>
  );
};

export default Header;
